import './index.scss';

const blockShortcode = () => {
	
};

export default blockShortcode;